export const ACTION_TYPE = 'actionType';
export const RECUR_ANNUALLY = 'recurAnnually';
export const STATIC_DATE_ANCHOR = 'staticDateAnchor';
export const CONTACT_PROPERTY_ANCHOR = 'contactPropertyAnchor';